const _jsxFileName = "C:\\Users\\MartinStein\\Documents\\Development\\open.CHECK\\open.CHECKLIST\\src\\js\\custom_wehn\\AuftragsstuecklistenPositionComponent.js"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, { } from "react";
import Parse from "parse";
import produce from "immer";

import { getListItem, getLagerOrteMap } from "./common";


import {

  List,
  Alert,

  Button,
  Input,
  Drawer,
  Col,
  Row,
  Select,
  Spin,
  Result,


} from "antd";

import { Icon } from "@opendash/icons";


import { $wehn } from "./state";
import { Artikel } from "./types-generated";
import { useSearchParams } from "react-router-dom";

export default function AuftragsstuecklistenPositionComponent(props) {
  const list = props.List;
  const listDepthIndex = props.index || 0;

  const [lagerOrte, setLagerOrte] = React.useState({});
  const currentList = list.objectId;
  const { Option } = Select;
  const [refreshing, setRefreshing] = React.useState(false);
  const [state, setState] = React.useState({
    showFilter: props.Filter.show,
    filter: props.Filter.value,
  });
  const inputid = "input_field_filter" + parseInt(Math.random() * 1000);

  const selectItem = (item) => {
    //O-Teil
    if (!item.artikel) return;

    //Position gesperrt
    if (item.gesperrt) return;

    // navigate(`/entnahme/AuftragsstuecklistenPosition/${item.objectId}`);

    $wehn.buchung.openDrawer({
      type: "AuftragsstuecklistenPosition",
      id: item.objectId,
    });
  };

  React.useEffect(() => {
    props.SetExtras([
      React.createElement(Row, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
        , React.createElement(Col, { xs: 24, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
          , React.createElement(Button, {
            style: { width: "80px" },
            type: "primary",
            icon: React.createElement(Icon, { icon: "fa:search", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}} ),
            key: "stockremoval_search",
            onClick: () => {
              setState(
                produce((draft) => {
                  draft.filter = "";
                  draft.showFilter = true;
                })
              );
            }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
          )
        )
      ),
    ]);
  }, []);
  React.useEffect(() => {
    setState(
      produce((draft) => {
        draft.showFilter = props.Filter.show;
        draft.filter = props.Filter.value;
      })
    );
  }, [props.Filter]);
  const subscribe = async () => {
    let livequery = new Parse.Query("AuftragsstuecklistenPosition");
    let aufList = new Parse.Object("Auftragsstueckliste");
    aufList.id = props.List.objectId;
    livequery.equalTo("auftragsstueckliste", aufList);
    let subscription = await livequery.subscribe();
    const liveUdpate = (object) => {
      update({ removals: [], restocked: [] });
      setRefreshing(true);
    };
    subscription.on("update", liveUdpate);
    subscription.on("create", liveUdpate);
  };
  React.useEffect(() => {
    setRefreshing(false);
  }, [props.List]);
  React.useEffect(() => {
    subscribe();
    let keydownListener = (e) => {
      if (
        e.target.tagName.toUpperCase() === "INPUT" ||
        (e.key.length > 1 && e.key.toLowerCase() !== "unidentified")
      ) {
        return;
      } else {
        setState(
          produce((draft) => {
            //draft.filter = e.key.toLowerCase() === "unidentified" ? "" : e.key;
            draft.showFilter = true;
          })
        );

        e.preventDefault();
        let el = document.getElementById("input_filter_field");
        if (el) el.focus();
      }
    };
    document.addEventListener("keydown", keydownListener);

    return () => {
      document.removeEventListener("keydown", keydownListener);
    };
  }, []);

  const [urlSearchParams, setUrlSearchParams] = useSearchParams();
  const setSelection = (selectedIndex) => {
    const params = {};
    let it = urlSearchParams.keys();
    let key = it.next();
    while (!key.done) {
      params[key.value] = urlSearchParams.get(key.value);
      key = it.next();
    }
    params["li" + listDepthIndex] = selectedIndex;
    setUrlSearchParams(params);
  };

  const selection = parseInt(urlSearchParams.get("li" + listDepthIndex));
  if (selection === undefined || selection === null || isNaN(selection)) {
    setSelection(-1);
  }

  const getLagerOrte = async () => {
    const positions =
      selection < 0 ? list.positions : list.children[selection].positions;

    const artikel = positions
      .map((pos) => _optionalChain([pos, 'access', _ => _.artikel, 'optionalAccess', _2 => _2.objectId]))
      .filter(Boolean)
      .map((artikelId) => Artikel.createWithoutData(artikelId));

    const result = await getLagerOrteMap(artikel);

    setLagerOrte(result);
  };

  React.useEffect(() => {
    getLagerOrte();
  }, [selection, list]);

  const update = (dataupdate) => {
    props.Update(dataupdate);
  };
  const search = () => {
    const mainQuery = new Parse.Query("Artikel").contains(
      "suchindex",
      state.filter.toLowerCase()
    );
    mainQuery.find().then((res) => {
      let items = res.map((item) => {
        let pItem = {};
        pItem["bezeichnung"] = item.get("bezeichnung");
        pItem["auftragsstueckliste"] = { objectId: currentList };
        pItem["position"] = "ungeplant";
        pItem["artikelnr"] = item.get("artikelnummer");
        pItem["menge"] = 0;
        pItem["auftrag"] = list.auftrag;
        pItem["fertig"] = item.get("fertig");
        pItem["auftragsposition"] = list.position;
        pItem["artikel"] = {
          type: "__pointer",
          className: "Artikel",
          objectId: item.id,
        };
        return pItem;
      });
      setState(
        produce((draft) => {
          draft.unplannedItems = items;
          draft.filter = "";
          draft.showFilter = false;
        })
      );
    });
  };
  const getFilter = () => {
    if (state.showFilter && selection == -1) {
      return (
        React.createElement(Alert, {
          style: {
            position: "fixed",
            left: "0px",
            right: "0px",
            top: "0px",
            zIndex: "9999",
          },
          message: "Aktiver Filter" ,
          description: 
            React.createElement('div', { id: inputid, __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}}
              , React.createElement(Input, {
                id: "input_filter_field",
                value: state.filter,
                autoFocus: true,
                onChange: (e) => {
                  const val = e.target.value;
                  setState(
                    produce((draft) => {
                      draft.filter = val;
                    })
                  );
                }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 220}}
              )
            )
          ,
          type: "info",
          closable: true,
          onClose: () => {
            setState(
              produce((draft) => {
                draft.filter = "";
                draft.showFilter = false;
              })
            );
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
        )
      );
    }
    return "";
  };

  const sortItems = (item1, item2) => {
    const doneFlag1 =
      item1.fertig &&
      !(
        (item1.mengeAngefordertNichtBestellt > 0 ||
          item1.mengeBestelltWehn > 0) &&
        item1.mengeIst == 0 &&
        item1.mengeSoll == 0
      );
    const mailFlag1 =
      item1.mengeAngefordertNichtBestellt > 0 || item1.mengeBestelltWehn > 0;
    const gesperrtFlag1 =
      !(
        item1.mengeAngefordertNichtBestellt > 0 || item1.mengeBestelltWehn > 0
      ) &&
      item1.gesperrt &&
      !item1.fertig;

    const doneFlag2 =
      item2.fertig &&
      !(
        (item2.mengeAngefordertNichtBestellt > 0 ||
          item2.mengeBestelltWehn > 0) &&
        item2.mengeIst == 0 &&
        item2.mengeSoll == 0
      );
    const mailFlag2 =
      item2.mengeAngefordertNichtBestellt > 0 || item2.mengeBestelltWehn > 0;
    const gesperrtFlag2 =
      !(
        item2.mengeAngefordertNichtBestellt > 0 || item2.mengeBestelltWehn > 0
      ) &&
      item2.gesperrt &&
      !item2.fertig;

    const begonnenFlag1 = !item1.fertig && item1.mengeIst > 0;
    const begonnenFlag2 = !item2.fertig && item2.mengeIst > 0;

    const oteilFlag1 = !item1.artikel;
    const oteilFlag2 = !item2.artikel;

    const keinBestandFlag1 =
      !doneFlag1 &&
      !begonnenFlag1 &&
      !_optionalChain([lagerOrte, 'access', _3 => _3[_optionalChain([item1, 'access', _4 => _4.artikel, 'optionalAccess', _5 => _5.objectId])], 'optionalAccess', _6 => _6.lagerNr]);
    const keinBestandFlag2 =
      !doneFlag2 &&
      !begonnenFlag2 &&
      !_optionalChain([lagerOrte, 'access', _7 => _7[_optionalChain([item2, 'access', _8 => _8.artikel, 'optionalAccess', _9 => _9.objectId])], 'optionalAccess', _10 => _10.lagerNr]);

    if (gesperrtFlag1 !== gesperrtFlag2) {
      if (gesperrtFlag1) return 1;
      return -1;
    }
    if (doneFlag1 !== doneFlag2) {
      if (doneFlag1) return 1;
      return -1;
    }
    if (oteilFlag1 !== oteilFlag2) {
      if (oteilFlag1) return 1;
      return -1;
    }
    if (mailFlag1 !== mailFlag2) {
      if (mailFlag1) return 1;
      return -1;
    }
    if (keinBestandFlag1 !== keinBestandFlag2) {
      if (keinBestandFlag1) return 1;
      return -1;
    }
    if (begonnenFlag1 !== begonnenFlag2) {
      if (begonnenFlag1) return 1;
      return -1;
    }

    const lager1 = _optionalChain([lagerOrte, 'access', _11 => _11[_optionalChain([item1, 'optionalAccess', _12 => _12.artikel, 'optionalAccess', _13 => _13.objectId])], 'optionalAccess', _14 => _14.lagerNr]) || 0;
    const lager2 = _optionalChain([lagerOrte, 'access', _15 => _15[_optionalChain([item2, 'optionalAccess', _16 => _16.artikel, 'optionalAccess', _17 => _17.objectId])], 'optionalAccess', _18 => _18.lagerNr]) || 0;
    //TODO if lager1 - lager2 ==0 -> Artikelnr
    return lager1 - lager2;
  };

  return (
    React.createElement('div', { style: props.style, className: "wehn-entnahme-stuecklisten", __self: this, __source: {fileName: _jsxFileName, lineNumber: 333}}
      , getFilter()
      , 
        React.createElement(Spin, { spinning: refreshing, __self: this, __source: {fileName: _jsxFileName, lineNumber: 336}}
          , React.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 337}})
        )
      
      , React.createElement(Select, {
        style: { width: "100%", marginBottom: "10px" },
        className: "stcklistselector",
        value: selection,
        onSelect: (val) => {
          setSelection(val);
        }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 340}}
      
        , React.createElement(Option, { value: -1, __self: this, __source: {fileName: _jsxFileName, lineNumber: 348}}, "Aktuelle Ebene: " + list.bezeichnung)

        , list.children
          ? list.children
              .sort((a, b) => a.BDENummer - b.BDENummer)
              .map((child, index) => {
                return (
                  React.createElement(Option, { style: { marginLeft: "10px" }, value: index, __self: this, __source: {fileName: _jsxFileName, lineNumber: 355}}
                    , child.bezeichnung
                  )
                );
              })
          : ""
      )
      , selection !== -1 && list.children && list.children[selection] ? (
        React.createElement(AuftragsstuecklistenPositionComponent, {
          SetExtras: props.SetExtras,
          index: listDepthIndex + 1,
          Filter: { show: state.showFilter, value: state.filter },
          style: { marginLeft: "10px" },
          List: list.children[selection],
          Stocks: lagerOrte,
          Update: update, __self: this, __source: {fileName: _jsxFileName, lineNumber: 363}}
        )
      ) : (
        React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 373}}
          , React.createElement(List, {
            style: { background: "#fff", padding: "12px" },
            itemLayout: "vertical",
            locale: {
              emptyText: (
                React.createElement(React.Fragment, null
                  , React.createElement(Button, {
                    type: "primary",
                    key: "console",
                    onClick: () => {
                      if (state.showFilter) {
                        search();
                      } else {
                        setState(
                          produce((draft) => {
                            draft.showFilter = true;
                            draft.filter = "";
                          })
                        );
                      }
                    }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 380}}
                  , "Artikel suchen und entnehmen"

                  )
                  , React.createElement(Result, { title: "Artikel in aktueller Stückliste nicht gefunden!"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 398}} )
                )
              ),
            },
            dataSource: list.positions
              .filter((item) => {
                return (
                  JSON.stringify(item)
                    .toLowerCase()
                    .indexOf((state.filter || "").toLowerCase()) != -1
                );
              })
              .sort((a, b) => {
                return sortItems(a, b);
              }),
            renderItem: (item) => {
              return getListItem(item, lagerOrte, selectItem);
            }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 374}}
          )
          , React.createElement(Drawer, {
            placement: "bottom",
            title: "Ungeplante Entnahme",
            visible: state.unplannedItems,
            closable: "true",
            onClose: () => {
              setState(
                produce((draft) => {
                  delete draft.unplannedItems;
                })
              );
            },
            height: "80%", __self: this, __source: {fileName: _jsxFileName, lineNumber: 417}}
          
            , React.createElement(List, {
              itemLayout: "vertical",
              dataSource: state.unplannedItems,
              renderItem: (item) => (
                React.createElement(List.Item, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 435}}
                  , React.createElement(List.Item.Meta, {
                    title: "" + item.artikelnr,
                    description: item.bezeichnung, __self: this, __source: {fileName: _jsxFileName, lineNumber: 436}}
                  )
                  , React.createElement(Button, {
                    onClick: () => {
                      setState(
                        produce((draft) => {
                          delete draft.unplannedItems;
                        })
                      );

                      // navigate(
                      //   `/entnahme/Artikel/${item.artikel.objectId}?auftrag=${list.auftrag.objectId}&aufpos=${list.auftragPosition.objectId}&stckliste=${currentList}`
                      // );

                      $wehn.buchung.openDrawer({
                        type: "Artikel",
                        artikelId: _optionalChain([item, 'access', _19 => _19.artikel, 'optionalAccess', _20 => _20.objectId]),
                        auftragId: _optionalChain([list, 'access', _21 => _21.auftrag, 'optionalAccess', _22 => _22.objectId]),
                        auftragpositionId: _optionalChain([list, 'access', _23 => _23.auftragPosition, 'optionalAccess', _24 => _24.objectId]),
                        stückliste: currentList,
                      });
                    }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 440}}
                  , "entnehmen"

                  )
                )
              ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 431}}
            )
          )
        )
      )
    )
  );
}
